import {ModalTiteledWindow} from "./modalWindow.js";
import {DataView} from '../dataview.js';
import {LabeledTextInput} from '../labeledTextInput.js';

export class ModalMultiSelectList extends ModalTiteledWindow {

   constructor(multiSelect, items, selectedItems) {
      super();

      this.multiSelect = multiSelect;
      this.set = multiSelect.set;
      this.items = items;
      this.selectedItems = selectedItems;

      this.setTitle(this.set.listTitle);

      this.elMain = HTMLElement.createFromHTML(
        `<div class="modal-multi-select-list">
               <div class="main">
                  <div class="search"><input type="text"></input></div>
                  <div class="items">
                     <div class="fav-list"></div>
                     <div class="list"></div>
                  </div>
                  <div class="buttons">
                     <div class="btn-cancel button-circle"><i class="icon-cross"></i></div>
                     <div class="btn-ok button-circle"><i class="icon-check"></i></div>
                  </div>
               </div>
         </div>`
      );

      this.search = new LabeledTextInput(this.elMain.querySelector('.search input'), {
         labelText: 'Suche', onChanging: (value) => { this.load(value); }
      });

      this.elMain.querySelector('.btn-cancel').onclick = () => {
         this.close();
      }

      this.elMain.querySelector('.btn-ok').onclick = () => {
         let items = this.dvFavList.getMultiActionItems().concat(this.dvList.getMultiActionItems());
         if (this.set.addData) {
            items = items.map(item => { return { data: item, info: {} }; });
         }
         this.multiSelect.addItems(items, true);
         this.close();
      }

      this.appendToBody(this.elMain);
      this.load(items, selectedItems, this.set, '');

      setTimeout(() => this.show(), 1);

   }

   load(searchValue) {

      // Elemente herausfiltern, die bereits gewählt wurden
      this.items.list   = this.items.list.filter(item => !this.selectedItems.includes(this.set.itemId(item)));
      this.items.favList = this.items.favList.filter(item => !this.selectedItems.includes(this.set.itemId(item)));

      let elList = this.elMain.querySelector('.items .list');
      let elFavList = this.elMain.querySelector('.items .fav-list');

      let list = this.items.list;
      let favList = this.items.favList;

      if (searchValue && searchValue.length > 0) {
         let re = new RegExp(searchValue, 'i');
         favList = this.items.favList.filter(item => this.set.itemTextValue(item).search(re) !== -1);
         list = this.items.list.filter(item => this.set.itemTextValue(item).search(re) !== -1);
      }

      if (this.items && this.items.favList) {
         favList.map(item => { item.sortKey = this.set.itemSortValue(item); });
         favList.sort(this.sortItems);
         this.dvFavList = new DataView(elFavList);
         this.dvFavList.load(favList, this.set.listSettings);
      }


      if (this.items && this.items.list) {
         list.map(item => { item.sortKey = this.set.itemSortValue(item); });
         list.sort(this.sortItems);
         this.dvList = new DataView(elList);
         this.dvList.load(list, this.set.listSettings);
      }


      /*
      if (this.items && this.items.favList) {
         this.items.favList.map(item => { item.sortKey = this.set.itemSortValue(item); });
         this.items.favList.sort(this.sortItems);
         this.dvFavList = new DataView(elFavList);
         this.dvFavList.load(this.items.favList, this.set.listSettings);
      }


      if (this.items && this.items.list) {
         this.items.list.map(item => { item.sortKey = this.set.itemSortValue(item); });
         this.items.list.sort(this.sortItems);
         this.dvList = new DataView(elList);
         this.dvList.load(this.items.list, this.set.listSettings);
      }
      */

      this.elMain.style.display = 'grid';

   }

   onSelect(value) {
      this.multiSelect.addItems([value].map(item => {
         if (this.set.addData) return { data: item, info: {} };
         else return item;
      }), true);
      this.close();
   }   

   sortItems(a,b) {
      return ( ( a.sortKey == b.sortKey ) ? 0 : ( ( a.sortKey > b.sortKey ) ? 1 : -1 ) );
   }



}
